import React, { createContext, useContext, useCallback } from "react";
import { useDispatch } from "react-redux";

import {
  useCountUnReadNotificationsQuery,
  notificationsAPI, // ← eto yung tamang import
} from "@/api/Endpoints/Core/Socials/Notifications";

const UnreadNotificationCountContext = createContext(null);

export const UnreadNotificationCountProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { data, refetch } = useCountUnReadNotificationsQuery();

  const count = data?.returnData ?? 0;

  const decrementCount = useCallback(() => {
    dispatch(
      notificationsAPI.util.updateQueryData( // ← notificationsAPI hindi notificationsApi
        "countUnReadNotifications",          // ← exact endpoint name: countUnRead + Notifications
        undefined,
        (draft) => {
          if (draft?.returnData > 0) {
            draft.returnData -= 1;
          }
        }
      )
    );
  }, [dispatch]);

  const incrementCount = useCallback(() => {
    dispatch(
      notificationsAPI.util.updateQueryData(
        "countUnReadNotifications",
        undefined,
        (draft) => {
          draft.returnData = (draft?.returnData ?? 0) + 1;
        }
      )
    );
  }, [dispatch]);

  const resetCount = useCallback(() => {
    refetch();
  }, [refetch]);

   const clearCount = useCallback(() => {
    dispatch(
      notificationsAPI.util.updateQueryData(
        "countUnReadNotifications",
        undefined,
        (draft) => {
          draft.returnData = 0;
        }
      )
    );
  }, [dispatch]);

  return (
    <UnreadNotificationCountContext.Provider
      value={{ count, decrementCount, incrementCount, resetCount,clearCount }}
    >
      {children}
    </UnreadNotificationCountContext.Provider>
  );
};

export const useUnreadNotificationCount = () => {
  const ctx = useContext(UnreadNotificationCountContext);
  if (!ctx) {
    throw new Error(
      "useUnreadNotificationCount must be used within UnreadNotificationCountProvider"
    );
  }
  return ctx;
};